import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoCourseMaterial } from "@/shared/model/edo-course-material.model";
import { IEdoCourse } from "@/shared/model/edo-course.model";
import { deleteEntity } from "@/shared/reducers/entities/edo-course-material.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";

interface DeleteCourseMaterialProps {
  courseMaterial: IEdoCourseMaterial;
  open: boolean;
  onClose?: () => void;
  onDelete?: (material: IEdoCourseMaterial) => void;
}

const DeleteCourseMaterial = (props: DeleteCourseMaterialProps) => {
  const dispatch = useAppDispatch();
  const { deleteSuccess } = useAppSelector<EntityState<IEdoCourse>>(
    (state) => state.edoCourseMaterial
  );

  const {
    open,
    onClose: handleOnClose,
    onDelete: handleOnDelete,
    courseMaterial,
  } = props;

  const handleCloseDialog = () => {
    if (handleOnClose) handleOnClose();
  };

  const confirmDelete = () => {
    dispatch(deleteEntity(courseMaterial.id)).then(() => {
      if (handleOnDelete) handleOnDelete(courseMaterial);
    });
  };

  useEffect(() => {
    if (deleteSuccess) {
      handleCloseDialog();
    }
  }, [deleteSuccess]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleCloseDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        {courseMaterial && (
          <p className="text-body text-[var(--color-mockup-text-mid)]">
            <Translate contentKey="edocendoApp.edoCourseMaterial.delete.question">
              Are you sure you want to delete this EdoSubjectleInsegnamento?
            </Translate>
          </p>
        )}
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleCloseDialog}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteCourseMaterial;
